import { NAMESPACE_MATCH_RESULT } from 'app/constants/Context';
import * as navigationSelectors from 'app/modules/Navigation/selectors';

import * as entitySelectors from './selectors/entities';
import * as presentationSelectors from './selectors/presentation';

// ---

export default {
  namespace: NAMESPACE_MATCH_RESULT,

  navigation: {
    selectors: navigationSelectors,
  },

  content: {
    selectors: entitySelectors,
  },

  grid: {
    selectors: presentationSelectors,
  },
};
